import React, { useState, useEffect } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Alert,
  AlertIcon,
  AlertDescription,
} from '@chakra-ui/react'

export function EditZoneModal({ isOpen, onClose, zone, onSave }) {
  const [name, setName] = useState('')
  const [zoneId, setZoneId] = useState('')

  useEffect(() => {
    if (zone) {
      setName(zone.name || '')
      setZoneId(zone.id_for_seat_ids || zone.name || '')
    }
  }, [zone, isOpen])

  const handleSave = () => {
    if (!name.trim()) return
    onSave({
      name: name.trim(),
      id_for_seat_ids: zoneId.trim() || name.trim(),
    })
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent>
        <ModalHeader>Change zone</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <FormControl isRequired>
              <FormLabel fontSize="sm" fontWeight="600">Name</FormLabel>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Zone name (e.g. Main Floor, Persian)"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontSize="sm" fontWeight="600">ID for seat IDs</FormLabel>
              <Input
                value={zoneId}
                onChange={(e) => setZoneId(e.target.value)}
                placeholder="Unique prefix for seat IDs"
              />
            </FormControl>

            <Alert status="warning" borderRadius="md" py={2} px={3}>
              <AlertIcon />
              <AlertDescription fontSize="xs">
                Should not be changed once the plan is in use.
              </AlertDescription>
            </Alert>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose} size="sm">
            Cancel
          </Button>
          <Button colorScheme="brand" onClick={handleSave} size="sm">
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
